// Dependencies
import styled from 'styled-components';

// Images
import quote from '../../../../img/icons/quote.svg';

const BlogPostImageQuoteStyles = styled.div`
  background-color: var(--color-sand);

  .right {
    padding: 2rem;
  }

  .image-wrapper {
    position: relative;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
  }

  .quote {
    font-size: 1.1rem;
    line-height: 1.8;
    font-style: italic;

    &::before {
      content: '';
      display: block;
      width: 2.5rem;
      height: 2.5rem;
      margin: 0 0 0.2rem;
      background-image: url(${quote});
    }
  }

  .attribution {
    margin-top: 1.1rem;
    font-size: 1rem;
    color: var(--color-graphite);
    text-transform: none;
  }

  @media (min-width: 768px) {
    display: flex;

    .left,
    .right {
      width: 50%;
    }

    .right {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 3rem;
    }

    .image-wrapper {
      margin: 0;

      .image {
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }

    .quote {
      width: 100%;
      font-size: 1.2rem;

      &::before {
        width: 3rem;
        height: 3rem;
      }
    }

    .attribution {
      margin-top: 1.2rem;
      width: 100%;
      font-size: 1rem;
    }
  }
`;

export default BlogPostImageQuoteStyles;
